/** Icons generated by create-react-icons. Don't edit this file directly. **/
import React from "react";
import PropTypes from "prop-types";

export function Unlink(props) {
  const { size, color, ...other } = props;
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      height={size}
      width={size}
      title="unlink-ico"
      {...other}
    >
      <path
        d="M18.5001 12.0001L19.6411 10.9221C20.5114 10.0518 21.0003 8.87142 21.0003 7.64064C21.0003 6.40985 20.5114 5.22948 19.6411 4.35914C18.7708 3.48889 17.5904 3 16.3596 3C15.1289 3 13.9485 3.48889 13.0781 4.35914L12.1911 5.24714"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6 4.5L18.5 19"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path
        d="M5.50014 11.0001L4.35914 12.0781C3.48889 12.9485 3 14.1289 3 15.3596C3 16.5904 3.48889 17.7708 4.35914 18.6411C5.22948 19.5114 6.40985 20.0003 7.64064 20.0003C8.87142 20.0003 10.0518 19.5114 10.9221 18.6411L11.8091 17.7531"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

Unlink.defaultProps = {
  color: "currentColor",
  size: 24,
};

Unlink.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};
